<template>
    <span
        :class="{'has-delete': canDelete}"
        class="badge badge-tag-outline inline-xs margin-bottom-xs margin-top-xs">
        {{name}}
        <r-button
            v-if="canDelete"
            type="link"
            class="grid-item no-flex modal-btn-close"
            @click="remove">
            <v-icon icon="close"/>
        </r-button>
    </span>
</template>

<script>
    import {vIcon} from '@/components/form';

    export default {
        name: 'v-tag',
        components: {vIcon},
        computed: {
            canDelete() {
                return this.$auth.tags.delete.isAllowed;
            },
        },
        props: {
            name: {
                type: String,
                default: null,
            },
        },
        methods: {
            remove($event) {
                this.$emit('remove', $event);
            },
        },
    };
</script>
